import { render, staticRenderFns } from "./familyEventListComp.vue?vue&type=template&id=62ace0f6&scoped=true"
import script from "./familyEventListComp.vue?vue&type=script&lang=js"
export * from "./familyEventListComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ace0f6",
  null
  
)

export default component.exports